/* eslint-disable no-unused-vars */
import React from 'react';
import style from './tagsContainer.module.scss';
import cx from 'classnames';
import { Tag, Tags } from 'store/types';
import Chip from '@mui/material/Chip';
import map from 'lodash-es/map';
import { useNavigate } from 'react-router-dom';

export default function TagsContainer(props: {
  children?: React.ReactNode;
  className?: string;
  tags?: Tags | Tag[];
}) {
  const navigate = useNavigate();

  // Может принять готовые компоненты, а может создать стандартные
  const addition = props.tags
    ? map(props.tags, (tag: Tag) => (
        <Chip
          onClick={() => {
            navigate(`/mapping?&tags=${tag.name}`, {
              replace: false,
            });
          }}
          label={tag.name}
          key={tag.name}
        />
      ))
    : [];

  return (
    <div className={cx(style.container, props.className)}>
      {props.children}
      {addition}
    </div>
  );
}
